import { CommonModule } from '@angular/common';
import { Component, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { PanelModule } from "primeng/panel";

@Component({
    selector: 'app-panel-wrapper',
    templateUrl: './panel-wrapper.component.html',
    encapsulation: ViewEncapsulation.Emulated,
    imports: [
        CommonModule,
        PanelModule
    ]
})
export class PanelWrapperComponent extends FieldWrapper {
  @ViewChild('fieldComponent', { read: ViewContainerRef })
  fieldComponent: ViewContainerRef;
}